var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenu01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16.6673 15H3.33398M16.6673 10H3.33398M16.6673 5H3.33398",
    stroke: "#2D96BE",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenu01);
export default __webpack_public_path__ + "static/media/ic-menu-01.2370c134710cdf8aa0070fdb5c8678a1.svg";
export { ForwardRef as ReactComponent };